import * as React from "react"
import { graphql } from "gatsby"
import { Seo } from "../components/seo"
import { getImage } from "gatsby-plugin-image"
import { Layout } from "../templates/siteLayout";
import { TemplateClient } from "../templates/templateClient"

export default function RenderClient(props) {
  const post = props?.data?.markdownRemark;
  return (
    <Layout>
      <TemplateClient post={post} />
    </Layout>
  )
}

export const pageQuery = graphql`
query GetClientById($id: String!) {
  markdownRemark(id: {eq: $id}) {
    frontmatter {
      date(formatString: "MMM Do, YYYY")
      dateTime: date(formatString: "YYYY-MM-DD")
      last_modified_at(formatString: "MMMM DD, YYYY")
      modifiedDate: last_modified_at(formatString: "YYYY-MM-DD")
      description
      title
      seo_title
      subtitle
      image {
        childImageSharp {
          gatsbyImageData
        }
      }
      author {
        name
      }
    }
    htmlAst
  }
}
`

export const Head = ({ data }) => {
  const { markdownRemark: post } = data
  return (
    <>
      <Seo
        title={post.frontmatter.seo_title ? post.frontmatter.seo_title : post.frontmatter.title}
        description={post.frontmatter.description}
        image={post.frontmatter.image ? getImage(post.frontmatter.image) : false}
        type="Article"
        attributes={
          {
            author: post.frontmatter.author?.name,
            published: post.frontmatter.dateTime,
            modified: post.frontmatter.modifiedDate
          }
        }
      >
      </Seo>
    </>
  )
}